<template>
    <div class="container">
        <div class="row justify-content-md-center">
            <div class="col-md-10">
                <div class="row">
                    <div class="col-md-6">
                        <div class="card">
                            <div class="card-header">
                                Editácia používateľa
                            </div>
                            <div class="card-body">
                                <UserForm :onSubmit="onSubmit"></UserForm>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="card">
                            <div class="card-header">
                                Nastavenie práv
                            </div>
                            <div class="card-body">
                                <b-form @submit="permissionsSubmit">
                                    <b-form-checkbox-group
                                        v-model="user.actualPermissions"
                                        :options="permissions"
                                        name="permissions"
                                        stacked
                                    ></b-form-checkbox-group>
                                    <br />
                                    <b-button
                                        type="submit"
                                        block
                                        variant="primary"
                                        >Uložiť
                                    </b-button>
                                </b-form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UserForm from "./components/UserForm";
import {
    FETCH_PERMISSIONS,
    FETCH_USER,
    UPDATE_USER,
    UPDATE_USER_PERMISSIONS
} from "../../../vuex/modules/actions.type";
import { mapGetters } from "vuex";

export default {
    name: "EditUser",
    components: { UserForm },
    data() {
        return {
            actualPermissions: [],
            loaded: false
        };
    },
    methods: {
        onSubmit(evt) {
            evt.preventDefault();

            this.$store
                .dispatch(UPDATE_USER)
                .then(data => {
                    if (data.data.id) {
                        this.$router.push({ name: "administration" });
                    }
                })
                .catch(() => {
                    this.$bvToast.toast("Niečo sa pokazilo", {
                        title: "Error",
                        variant: "danger",
                        toaster: "b-toaster-top-right",
                        solid: true,
                        appendToast: true
                    });
                });
        },
        fetchUser() {
            this.$store.dispatch(FETCH_USER, {
                id: this.$route.params.id
            });
        },
        loadPermissions() {
            this.$store.dispatch(FETCH_PERMISSIONS);
        },
        permissionsSubmit(evt) {
            evt.preventDefault();
            this.$store
                .dispatch(UPDATE_USER_PERMISSIONS)
                .then(() => {
                    this.$router.push({ name: "administration" });
                })
                .catch(() => {
                    alert("Niečo sa pokazilo");
                });
        }
    },
    mounted() {
        this.fetchUser();
        this.loadPermissions();
    },
    // updated() {
    //     if (!this.loaded && this.user.permissions) {
    //         this.loaded = true;
    //         let actual = this.user.permissions.map(item => {
    //             return item.id;
    //         });
    //         this.user.actualPermissions = actual || [];
    //     }
    // },
    computed: {
        ...mapGetters({
            permissions: "permissions",
            user: "user"
        })
    }
};
</script>

<style scoped></style>
